// extracted by mini-css-extract-plugin
export default {"tableContainer":"ebooks_tableContainer__sXEkR"};